import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ReleaseNoteAdminComponent } from './release-note-admin.component';
import { ReleaseNoteFormComponent } from './components/release-note-form/release-note-form.component';
import { ReleaseNotesListComponent } from './components/release-notes-list/release-notes-list.component';
import { ReleaseNoteDialogComponent } from './dialog/release-note-dialog/release-note-dialog.component';

@NgModule({
  declarations: [ReleaseNoteAdminComponent, ReleaseNoteFormComponent, ReleaseNotesListComponent, ReleaseNoteDialogComponent],
  imports: [CommonModule, SharedModule],
  exports: [ReleaseNoteAdminComponent, ReleaseNoteFormComponent, ReleaseNotesListComponent, ReleaseNoteDialogComponent],
})
export class ReleaseNoteAdminModule {}
